import React from "react";
import { LoginContextProvider } from "./Auth/LoginContext";
import { CartProvider } from "./Cart/CartContext";
const ContextProvider = ({ children }) => {
  return (
    <LoginContextProvider>
      <CartProvider>{children}</CartProvider>
    </LoginContextProvider>
  );
};

export default ContextProvider;
